import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const EducatorIcon = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 20 20"
      data-fill-none
    >
      <path
        d="M17.9484 18.5938C18.3331 17.4836 18.5546 16.5539 18.682 15.8352C18.8683 14.7813 18.2921 13.7898 17.2999 13.3887C15.6324 12.7152 13.9687 12.3438 13.9687 12.3438C13.9687 11.6742 13.9011 10.2656 13.8452 9.2207C13.8038 8.44336 13.2956 7.75273 12.5202 7.67969C12.3644 7.66523 12.1999 7.65625 12.0288 7.65625C11.8199 7.65625 11.6179 7.67461 11.43 7.70352C10.6894 7.81719 10.2581 8.52227 10.2581 9.27148V13.5156L9.6472 14.0188C9.0515 14.5102 8.71634 15.2676 8.86205 16.0262C9.09095 17.2176 9.45345 17.9383 9.7847 18.5938"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6172 10.9757C17.6965 10.0538 17.8125 8.61669 17.8125 7.06942C17.8125 5.09872 17.7023 3.62372 17.5988 2.67372C17.5622 2.31946 17.3901 1.99308 17.1184 1.76281C16.8467 1.53254 16.4965 1.41622 16.141 1.43817C13.5684 1.57802 11.8715 2.16083 9.98672 3.15536C9.8704 3.2167 9.74088 3.24876 9.60938 3.24876C9.47787 3.24876 9.34835 3.2167 9.23203 3.15536C7.34766 2.16083 5.65 1.57802 3.07812 1.43817C2.72266 1.41622 2.37247 1.53254 2.10078 1.76281C1.82909 1.99308 1.65693 2.31946 1.62031 2.67372C1.51641 3.62372 1.40625 5.09872 1.40625 7.06942C1.40625 9.04013 1.51641 10.5151 1.61992 11.4651C1.70039 12.2058 2.33398 12.7261 3.07773 12.7663C4.65625 12.8522 6.10078 13.1022 7.26562 13.5147"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.60938 3.35938V6.09375"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);
